<div class="list-group">
  @for (osupdate of osupdates(); track osupdate) {
    <era-os-update-list-item class="list-group-item"
                             [class.active]="allowSelecting() && selectedOsUpdate === osupdate"
                             [class.list-group-item-action]="allowSelecting()"
                             [osupdate]="osupdate"
                             [isEditing]="isEditing()"
                             [allowEditing]="allowEditing()"
                             (deleted)="delete($event)"
                             (click)="select(osupdate)">
    </era-os-update-list-item>
  }

  @if (osupdates().length === 0) {
    <p class="text-muted m-2">No updates are selected.</p>
  }
</div>